import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { FormGlobalComment } from './FormGlobalComment';
import { Dialog } from 'primereact/dialog';
export const ModalCrudGlobalComment = (props) => {

    const {
        method, modalCrudComment, toggleCrudComment, saveCreate, handleInputChange, text, type,keyComments
        
    } = props;

    return (
         <Dialog 
            header={
                method === "create" ?
                    "Comentario Global"
                    : (method === "update") ?
                        "Actualizar Comentario"
                        : null

            }
            visible={modalCrudComment}
            onHide={toggleCrudComment}
            key={keyComments} 
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
            >
      
            {
                method === "create" ? 
                    <FormGlobalComment
                        button="Crear comentario global"
                        {...{ toggleCrudComment, saveCreate, handleInputChange, text, type}}
                    />
                    : (method === "update") ?
                        <FormGlobalComment
                            button="Actualizar comentario"
                            {...{toggleCrudComment, saveCreate, handleInputChange, text, type}}
                        />
                        : null
                       
            }
        </Dialog>
    )
}

